import { Component, inject, OnInit, output } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../app.state';
import { TranslocoModule } from '@jsverse/transloco';

interface Consumer {
  id: string
  name: string
}

@Component({
  selector: 'pixl-consumer-cb',
  imports: [
    MatSelectModule,
    TranslocoModule
  ],
  templateUrl: './consumer-cb.component.html',
  styleUrl: './consumer-cb.component.scss'
})
export class ConsumerFilterCBComponent implements OnInit {
  private store = inject(Store);
  private appState$ = this.store.select(AppSelectors.appState);
  public consumers: Consumer[] = [];
  public onStateChange = output<string>();

  public ngOnInit() {
    this.appState$.subscribe(({ isLoaded, consumers }) => {
      if (isLoaded) {
        this.consumers = [];

        consumers.forEach((entry) => {
          this.consumers.push({
            id: entry.id,
            name: entry.name
          });
        });

        this.consumers = [...this.consumers.sort((a, b) => {
          if (a.name === '---') {
            return -1;
          }
          if (b.name === '---') {
            return 1;
          }

          return a.name.localeCompare(b.name);
        })];
      }
    });
  }

  public onChangeEvent(ev: string): void {
    this.onStateChange.emit(ev);
  }

  public getAllConsumers(): Consumer[] {
    return this.consumers;
  }
}
